/**
 * 提示音
 * @param {string} type 提示类型 warning/success/error
 */

function notification(type) {
  let audioUrl = null
  if (type === 'warning') {
    audioUrl = 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/Music/Windows%20Foreground.wav'
  }
  if (type === 'success') {
    audioUrl = 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/Music/Windows%20Notify.wav'
  }
  if (type === 'error') {
    audioUrl = 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/Music/Windows%20Background.wav'
  }
  const audio = new Audio(audioUrl)
  audio.play().catch(e => console.log(e))
}

export { notification }
